<template>
  <section class="eva-page">
    <v-row>
      <v-col
        cols="12"
        offset="0"
        md="10"
        offset-md="1"
      >
        <div class="eva-top">
          <v-breadcrumbs
            large
            :items="crumbs"
            divider="/"
            class="pl-0"
          />

          <div class="eva-title">
            <v-icon
              color="primary"
              class="mr-2"
            >
              mdi-file-document-edit-outline
            </v-icon>

            <span class="primary--text">
              Editar Formulário de Formação
            </span>
          </div>
        </div>

        <div
          v-if="initialLoading"
          class="d-flex justify-center py-12"
        >
          <v-progress-circular
            indeterminate
            color="primary"
            size="50"
          />
        </div>

        <div
          v-else
          class="mt-6"
        >
          <Formulario
            :value="form"
            :loading="loading"
            title="Editar Formulário"
            submit-text="Guardar alterações"
            @submit="updateFormulario"
            @cancel="goBack"
          />
        </div>
      </v-col>
    </v-row>

    <DialogSuccess
      :opened="success"
      @on-ok="onSuccess"
    >
      Formulário de formação atualizado com sucesso
    </DialogSuccess>
  </section>
</template>

<script>
import Formacoes from "@/api/Formacoes.js";

import Formulario from "@/components/Formacoes/Formularios/Formulario.vue";

import DialogSuccess from "@/components/UI/DialogSuccess.vue";

export default {
  name: "UpdateFormulario",

  components: {
    Formulario,
    DialogSuccess,
  },

  beforeCreate() {
    document.title =
      "ODC - Editar Formulário de Formação";
  },

  data() {
    return {
      initialLoading: true,

      loading: false,

      success: false,

      form: {
        id: null,
        nome: "",
        codigo: "",
        descricao: "",
        is_active: true,
        campos: [],
      },
    };
  },

  computed: {
    formularioId() {
      return this.$route.params.id;
    },

    crumbs() {
      return [
        {
          text: "Dashboard",
          disabled: false,
          to: "/admin",
          exact: true,
        },
        {
          text: "Formações",
          disabled: false,
          to: "/trainings",
          exact: true,
        },
        {
          text: "Formulários",
          disabled: false,
          to: "/trainings/forms",
          exact: true,
        },
        {
          text:
            this.form.nome
            || "Editar",
          disabled: true,
        },
      ];
    },
  },

  mounted() {
    if (
      !this.$store.getters.hasPermission([
        "super",
        "trainings.forms.create",
      ])
    ) {
      this.$router.push(
        "/trainings"
      );

      return;
    }

    this.getFormulario();
  },

  methods: {
    getFormulario() {
      this.initialLoading =
        true;

      Formacoes
        .getFormulario(
          this.formularioId
        )
        .then((response) => {
          const data =
            response.data
            || {};

          this.form = {
            id:
              data.id,

            nome:
              data.nome
              || "",

            codigo:
              data.codigo
              || "",

            descricao:
              data.descricao
              || "",

            is_active:
              data.is_active !== undefined
                ? Boolean(
                    data.is_active
                  )
                : true,

            campos:
              data.campos
              || [],
          };
        })
        .catch(() => {
          this.$router.push(
            "/trainings/forms"
          );
        })
        .finally(() => {
          this.initialLoading =
            false;
        });
    },

    updateFormulario(payload) {
      if (
        this.loading
      ) {
        return;
      }

      this.loading =
        true;

      Formacoes
        .updateFormulario(
          this.formularioId,
          payload
        )
        .then((response) => {
          const data =
            response.data
            || {};

          this.form = {
            id:
              data.id,

            nome:
              data.nome
              || "",

            codigo:
              data.codigo
              || "",

            descricao:
              data.descricao
              || "",

            is_active:
              data.is_active !== undefined
                ? Boolean(
                    data.is_active
                  )
                : true,

            campos:
              data.campos
              || [],
          };

          /*
           * Abre a DialogSuccess apenas depois
           * de o backend guardar com sucesso.
           */
          this.success =
            true;
        })
        .catch((error) => {
          console.error(
            "[UpdateFormulario] Erro ao atualizar formulário:",
            error
          );
        })
        .finally(() => {
          this.loading =
            false;
        });
    },

    onSuccess() {
      this.success =
        false;
    },

    goBack() {
      this.$router.push(
        "/trainings/forms"
      );
    },
  },
};
</script>

<style scoped>
.eva-page {
  padding-bottom: 32px;
}

.eva-top {
  margin-top: 8px;
}

.eva-title {
  display: flex;
  align-items: center;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.2px;
}
</style>